import { Component, ViewChild, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NDCDetails } from 'src/app/models/NDCDetails';
import { BillingService } from 'src/app/Services/AdminConfigurations/billing.service';
import { ICptOrdersComponent } from 'src/app/models/ICptOrdersComponent';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IProcedureFee } from 'src/app/models/IProcedureFee';
import { ToastrService } from 'ngx-toastr';

export interface IclaimType {
  claimType: string;
  claimValue: string;
}

@Component({
  selector: 'app-manage-ndc',
  templateUrl: './manage-ndc.component.html',
  styleUrls: ['./manage-ndc.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class ManageNdcComponent implements OnInit {

  claimTypeList: IclaimType[] = [
    { claimType: "PROFESSIONAL", claimValue: "PROFESSIONAL" },
    { claimType: "INSTITUTIONAL", claimValue: "INSTITUTIONAL" },
  ]

  columnsToDisplay = ['ndcTitle', 'claimType', 'cptCode', 'cptMod', 'ndcCode', 'price', 'activeStatus'];
  headercolumnsToDisplay = ['Title', 'Claim Type', 'CPT Code', 'Modifier', 'NDC', 'Price', 'Active Status'];
  dataSource: any = new MatTableDataSource();
  expandedElement: NDCDetails | null;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  public show: boolean = false;
  showInfo() {
    this.show = !this.show;
    this.expandedElement = null;
    this.clearNDC();
  }
  managendcform: FormGroup;
  submitted = false;
  public manageNDCObj: NDCDetails;
  public NDCMangeList: NDCDetails[];
  public existList: NDCDetails[];
  public updatedList: NDCDetails[];
  public existUpdatedList: NDCDetails[];
  public cptCodeList: IProcedureFee[];
  public cptCodeDetails: IProcedureFee[];
  public ProcedureCPTCodeList: IProcedureFee[];
  public modifierList: IProcedureFee[];
  public facilityId= Number(sessionStorage.getItem("FacilityId"));
  public modifier: string = '';

  selectedClaim: string;
  selectedCPTCode: string;
  selectedClaim1: string;
  selectedCPTCode1: string;

  constructor(private formBuilder: FormBuilder, private billingService: BillingService
    , private sharedService: SharedService,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.managendcform = this.formBuilder.group({
      title: [''],
      claim: [''],
      cpt: [''],
      modifier: [''],
      ndc: [''],
      unit: [''],
      isActive: [''],
      ndcTitle: [''],
      cptCode: [''],
      price: [''],
      cptMod: [''],
      ndcCode: [''],
      claimType: [''],
    });

    this.getManageNDCDetails(this.facilityId);
    //this.getAllCPTCodes();
    this.getProcedureCptDetails();
  }

  get f() { return this.managendcform.controls; }

  SaveManageNDC(mode: string) {
    if (this.managendcform.invalid) {
      return;
    }
    let valid: boolean = this.NDCValidations();
    if (valid) {
      this.existList = this.NDCMangeList.filter(x => x.claimType === this.managendcform.value.claim && x.cptCode === this.managendcform.value.cpt && x.ndcCode === this.managendcform.value.ndc);
      if (this.existList.length > 0) {
        this.toastr.warning("This NDC Details Already Exist");
        return;
      }

      this.manageNDCObj = new NDCDetails();
      this.manageNDCObj.ndcTitle = this.managendcform.value.title;
      this.manageNDCObj.cptCode = this.managendcform.value.cpt;
      this.manageNDCObj.price = this.managendcform.value.unit;
      this.manageNDCObj.ndcCode = this.managendcform.value.ndc;
      this.manageNDCObj.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
      this.manageNDCObj.claimType = this.managendcform.value.claim;
      this.manageNDCObj.isActive = this.managendcform.value.isActive;
      this.manageNDCObj.mode = mode;
      this.manageNDCObj.facilityId = Number(sessionStorage.getItem("FacilityId"));;

      this.billingService.saveManageNDCDetails(this.manageNDCObj).subscribe(
        results => {
          let message = results;
          this.getManageNDCDetails(this.facilityId);
          this.toastr.success(message);
          this.clearNDC();
        }, (err: any) => console.log(err));
    }

  }

  NDCValidations() {
    let isValid: boolean = true;
    if (this.managendcform.value.title == "" || this.managendcform.value.cpt == "" || this.managendcform.value.ndc == "" || this.managendcform.value.claim == "") {
      isValid = false;
      this.toastr.warning("Enter All NDC Details");
    }
    return isValid;
  }

  getManageNDCDetails(facilityId: number) {
    this.billingService.getManageNDCDetials(facilityId).subscribe(
      results => {
        this.NDCMangeList = results;
        this.dataSource.data = this.NDCMangeList;
        this.dataSource.paginator = this.paginator;
      }, (err: any) => console.log(err));
  }

  onCellClick(element: NDCDetails) {
    this.show = false;
    this.managendcform.patchValue({
      ndcTitle: element.ndcTitle,
      claimType: element.claimType,
      cptCode: element.cptCode,
      //cptMod: element.cptMod,
      ndcCode: element.ndcCode,
      price: element.price,
      isActive: element.isActive
    });
  }

  NDCUpdateValidations() {
    let isValid: boolean = true;
    if (this.managendcform.value.ndcTitle == "" || this.managendcform.value.cptCode == "" || this.managendcform.value.ndcCode == "" || this.managendcform.value.claimType == "") {
      isValid = false;
      this.toastr.warning("Enter All NDC Details");
    }
    return isValid;
  }
  updateManageNDC(element: NDCDetails, mode: string) {
    if (this.managendcform.invalid) {
      return;
    }
    let valid: boolean = this.NDCUpdateValidations();
    if (valid) {
      this.updatedList = this.NDCMangeList.filter(x => x.ndcId !== element.ndcId);
      var claimTpye = this.managendcform.value.claimType;
      var cptCode = this.managendcform.value.cptCode;
      var ndcCode = this.managendcform.value.ndc
      this.existUpdatedList = this.updatedList.filter(x => x.claimType === claimTpye && x.cptCode === cptCode && x.ndcCode === ndcCode);
      if (this.existUpdatedList.length > 0) {
        this.toastr.warning("This NDC Details Already Exist");
        return;
      }

      this.manageNDCObj = new NDCDetails();
      this.manageNDCObj.ndcId = element.ndcId
      this.manageNDCObj.ndcTitle = this.managendcform.value.ndcTitle;
      this.manageNDCObj.cptCode = this.managendcform.value.cptCode;
      this.manageNDCObj.price = this.managendcform.value.price;
      this.manageNDCObj.ndcCode = this.managendcform.value.ndcCode;
      this.manageNDCObj.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
      this.manageNDCObj.claimType = this.managendcform.value.claimType;
      this.manageNDCObj.isActive = this.managendcform.value.isActive;
      this.manageNDCObj.mode = mode;
      this.manageNDCObj.facilityId = Number(sessionStorage.getItem("FacilityId"));

      this.billingService.saveManageNDCDetails(this.manageNDCObj).subscribe(
        results => {
          let message = results;
          this.getManageNDCDetails(this.facilityId);
          this.toastr.success(message);
        }, (err: any) => console.log(err));
    }
  }

  getProcedureCptDetails() {
    this.billingService.getProcedureFee().subscribe(
      data => {
        this.ProcedureCPTCodeList = data;
      }, (err: any) => console.log(err));
  }

  onSelectClaimType() {
    if (this.selectedClaim === undefined) {
      this.claimTypeList;
    } else {
      this.cptCodeList = this.ProcedureCPTCodeList.filter(x => x.type === this.selectedClaim);
    }
  }

  onSelectCPTCOde(event) {
    if (this.selectedCPTCode === undefined) {
      this.cptCodeList;
    } else {
      this.modifierList = this.cptCodeList.filter(x => x.cptCode === this.selectedCPTCode);
      this.managendcform.patchValue({
        modifier: this.modifierList[0].modifier,
      });
    }
  }


  onSelectMatTabClaimType() {
    if (this.selectedClaim1 === undefined) {
      this.claimTypeList;
    } else {
      this.cptCodeDetails = this.ProcedureCPTCodeList.filter(x => x.type === this.selectedClaim1);
    }
  }


  onSelectMatTabCPTCOde() {
    if (this.selectedCPTCode1 === undefined) {
      this.cptCodeDetails;
    } else {
      this.modifierList = this.cptCodeDetails.filter(x => x.cptCode === this.selectedCPTCode1);
      this.managendcform.patchValue({
        cptMod: this.modifierList[0].modifier,
      });
    }
  }

  clearNDC() {
    this.managendcform.patchValue({
      title: '',
      claim: '',
      cpt: '',
      modifier: '',
      ndc: '',
      unit: '',
      isActive: false,
    });
  }

  NDCCancel() {
    this.expandedElement = null;
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

}


